var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.66667V10.4467L11.5534 9.66667H1.66671V1.66667H12.3334ZM12.3334 0.333332H1.66671C0.933374 0.333332 0.333374 0.933332 0.333374 1.66667V9.66667C0.333374 10.4 0.933374 11 1.66671 11H11L13.6667 13.6667V1.66667C13.6667 0.933332 13.0667 0.333332 12.3334 0.333332ZM11 7H3.00004V8.33333H11V7ZM11 5H3.00004V6.33333H11V5ZM11 3H3.00004V4.33333H11V3Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.131ccff8.svg";
export { ForwardRef as ReactComponent };